<template>
    <b-container>
      <p>{{ currentKey.Status === 'active' ? $t('action.removeKey') : $t('action.restoreKey') }}</p>
      <ul>
        <li>
          Source: {{ currentKey.Source }} 
        </li>
        <li>
          Client: {{ currentKey.Client }} 
        </li>
        <li>
          NOCIE: {{ currentKey.NOCIE }} 
        </li>
        <li>
          NODIV: {{ currentKey.NODIV }} 
        </li>
      </ul>
      <b-button class="mt-4 text-center" variant="danger" @click="removeKey()" :disabled="disabled">{{ $t("action.confirmed") }}</b-button>
    </b-container>
  </template>
  
  <script>
  import axios from "axios";
  import { globalF } from "../../Helpers";
  
  export default {
    mixins: [globalF],
    props: ["currentKey", "modalid"],
    data() {
      return {
        error: "",
        spinner: false,
        disabled: false
      };
    },
    mounted() {},
    computed: {},
    methods: {
      removeKey() {
        this.spinner = true;
        this.error = "";
        let urls = this.$store.getters.getUrlsList;
        let url = urls[process.env.VUE_APP_WHERE].json;

        let request = this.currentKey.Status === 'active' ? "removeKey" : "restoreKey";
  
        let promise = this.validateToken();
        promise.then(() => {
          axios
            .post(
              url,
              { request: request, clientKey: this.currentKey.Id },
              { headers: { "Content-Type": "application/json" } }
            )
            .then(() => {
              this.spinner = false;
              this.$bvModal.hide(this.modalid);
            })
            .catch(() => {
              this.spinner = false;
              this.error = this.$t("info.errorgeneric");
            });
        });
      },
    },
  };
  </script>
  